import React from 'react';
import cx from 'classnames';

export default class PlayDuration extends React.PureComponent {
  render() {
    const { duration, smallRibbon } = this.props;

    return (
      <div className={cx('ribbon ribbon-play-duration', { 'ribbon-small': smallRibbon })}>
        { duration > 0 && <span className="duration">{ Math.ceil(duration / 60) } min</span> }
        <i className="icon-play"></i>
      </div>
    );
  }
}

PlayDuration.propTypes = {
  duration: React.PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/component/PlayDuration.jsx